import styled from 'styled-components';
import { IconStatusError } from '../../Icons/IconStatusError.js';
import { A2E_DATA_TESTIDS } from '../constants.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var ValidationContainer = styled.div.withConfig({
  displayName: "ActivateToEditValidationContainer__ValidationContainer",
  componentId: "sc-frraz4-0"
})(["&&{display:flex;align-items:center;gap:6px;}"]);
var ActivateToEditValidationContainer = function ActivateToEditValidationContainer(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/jsxs(ValidationContainer, {
    "data-testid": A2E_DATA_TESTIDS.validationContainer,
    children: [/*#__PURE__*/jsx(IconStatusError, {
      size: 16
    }), /*#__PURE__*/jsx("span", {
      children: message
    })]
  });
};

export { ActivateToEditValidationContainer };
